module.exports = __webpack_public_path__ + "5bee74caefdf9d0a834915f6c8eeb259.svg";